export default {
  activeFilters: state => state.activeFilters,

  activeDashboardId: state => state.activeDashboardId,

  dashboardConfig: state => state.dashboardConfig || { tabs: [] },

  hasActiveFilters: state => {
    return Object.values(state.activeFilters).some(
      v => v !== "" && v !== null && v !== undefined
    )
  },

  getChartsData: (state) => state.chartsData,

  getChartsLoading: (state) => state.chartsLoading,

  getChartsErrors: (state) => state.chartsErrors,

  getIndicatorsByTabId: (state) => tabId => state.indicators[tabId],

  getFilterFieldOptions: state => state.filterFieldOptions,
}
